import jQuery from 'jquery'

function textify(html) {
  let $html = jQuery(html)

  // .v-number
  $html.find('.v-number').remove()

  // [target]
  $html.find('[target]').remove()

  // ruby > rt
  $html.find('rt').remove()

  return $html.text()
}

export {
  textify,
}
